import type { RouteLocationNormalized } from "vue-router";

import AffiliateService from "@/modules/settings/services/affiliate/AffiliateService";

export default class AffiliateGuard {
  static async getStats(to: RouteLocationNormalized) {
    to.meta.affiliateStats = await AffiliateService.getStats();
  }
}
